import { render, staticRenderFns } from "./FullscreenMessage.vue?vue&type=template&id=a50776d0&scoped=true&"
import script from "./FullscreenMessage.vue?vue&type=script&lang=ts&"
export * from "./FullscreenMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenMessage.vue?vue&type=style&index=0&id=a50776d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50776d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a50776d0')) {
      api.createRecord('a50776d0', component.options)
    } else {
      api.reload('a50776d0', component.options)
    }
    module.hot.accept("./FullscreenMessage.vue?vue&type=template&id=a50776d0&scoped=true&", function () {
      api.rerender('a50776d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FullscreenMessage.vue"
export default component.exports